export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مرشحات"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المتجر"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحساب"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مسح الكل"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر الحالة"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر المتجر"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الفاتورة"])}
}